export default __webpack_public_path__ + "static/media/main-layer-0.14258ee2.png";